import React from 'react';
import Table from 'components/Table';
import RemoveInput from 'components/RemoveInput';
import { Form, Input, Select, Checkbox } from 'antd';
import theme from 'shared/constants/theme.json';

const comparison = [
  {
    value: 'url_equals',
    label: 'URL equals',
  },
  {
    value: 'url_contains',
    label: 'URL contains',
  },
  {
    value: 'url_startswith',
    label: 'URL starts with',
  },
  {
    value: 'url_endswith',
    label: 'URL ends with',
  },
  {
    value: 'url_regexp',
    label: 'URL matches the expression',
  },
  {
    value: 'path_equals',
    label: 'Path equals',
  }, {
    value: 'path_contains',
    label: 'Path contains',
  },
  {
    value: 'path_startswith',
    label: 'Path start with',
  },
  {
    value: 'path_endswith',
    label: 'Path Ends with',
  },
  {
    value: 'query_contains',
    label: 'Search query contains',
  },
  {
    value: 'pagetitle_equals',
    label: 'Page Title equals',
  },
  {
    value: 'pagetitle_contains',
    label: 'Page Title contains',
  },
  {
    value: 'pagetitle_startswith',
    label: 'Page Title starts with',
  },
  {
    value: 'pagetitle_endswith',
    label: 'Page Title ends with',
  },
  {
    value: 'eventcategory_equals',
    label: 'Event Category equals',
  },
  {
    value: 'eventcategory_contains',
    label: 'Event Category contains',
  },
  {
    value: 'eventcategory_startswith',
    label: 'Event Category starts with',
  },
  {
    value: 'eventcategory_endswith',
    label: 'Event Category ends with',
  },
  {
    value: 'eventname_equals',
    label: 'Event Name equals',
  },
  {
    value: 'eventname_contains',
    label: 'Event Name contains',
  },
  {
    value: 'eventname_startswith',
    label: 'Event Name starts with',
  },
  {
    value: 'eventname_endswith',
    label: 'Event Name ends with',
  },
  {
    value: 'eventaction_equals',
    label: 'Event Action equals',
  },
  {
    value: 'eventaction_contains',
    label: 'Event Action contains',
  },
  {
    value: 'eventaction_startswith',
    label: 'Event Action starts with',
  },
  {
    value: 'eventaction_endswith',
    label: 'Event Action ends with',
  },
];
const FunnelStepTable = ({ fields, remove, disabled, validationResults }) => {
  const funnelColumns = [
    {
      title: 'Step',
      dataIndex: 'position',
      render: (_, __, index) => index + 1,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      render: (_, field) => (
        <Form.Item name={[field.name, 'name']} rules={[{ required: true, message: 'Name is required' }]}>
          <Input disabled={disabled} />
        </Form.Item>
      ),

    },
    {
      title: 'Comparison',
      dataIndex: 'comparison',
      render: (_, field) => (
        <Form.Item name={[field.name, 'patternType']}>
          <Select
            options={comparison}
            disabled={disabled}
          />
        </Form.Item>
      ),
    },
    {
      title: 'Pattern',
      dataIndex: 'pattern',
      render: (_, field) => (
        <Form.Item name={[field.name, 'pattern']} rules={[{ required: true, message: 'Pattern is required' }]}>
          <Input disabled={disabled} />
        </Form.Item>
      ),
    },
    {
      title: 'Required',
      dataIndex: 'required',
      render: (_, field) => (
        <Form.Item name={[field.name, 'required']} valuePropName="checked">
          <Checkbox disabled={disabled} />
        </Form.Item>
      ),
    },
    {
      title: 'Validation',
      dataIndex: 'matchUrl',
      render: (_, field, index) => {
        const isMatching = validationResults.length > index && validationResults[index].isMatching;
        if (validationResults.length === 0) {
          return null;
        }
        return (
          <span style={{ color: theme[isMatching ? 'success-color' : 'error-color'] }}>
            {isMatching ? 'Matching' : 'Not matching'}
          </span>
        );
      },
    },
  ];

  return (

    <Table
      dataSource={fields}
      columns={funnelColumns}
      pagination={false}
      rowKey="key"
      disabled={disabled}
      actions={(field) => (disabled ? null : <RemoveInput onRemove={() => remove(field.name)} />)}
      emptyMessage="No steps added"
    />

  );
};

export default FunnelStepTable;
